/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { apieventmeslist } from '@/api';
import { mapState } from 'vuex';
import UserLogo from '@/components/UserLogo';
import ScrollerList from '@/components/ScrollerList';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Previewer from "vux/src/components/previewer/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
export default {
  components: {
    ViewBox: ViewBox,
    Previewer: Previewer,
    UserLogo: UserLogo,
    ScrollerList: ScrollerList
  },
  directives: {
    // 指令
    TransferDom: TransferDom
  },
  props: {
    eventId: String
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['config'])), {}, {
    scrollerHight: function scrollerHight() {
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 50 - 3.6 * fontSize;
    }
  }),
  data: function data() {
    return {
      pageIndex: 0,
      pageSize: 10,
      list: [],
      picsForPreviewer: [],
      options: {
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
          if (thumbnail) {
            var _thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
            var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
            if (_thumbnail.getBoundingClientRect) {
              var rect = _thumbnail.getBoundingClientRect();
              return {
                x: rect.left,
                y: rect.top + pageYScroll,
                w: rect.width
              };
            }
          }
        }
      }
    };
  },
  methods: {
    translate: function translate(str) {
      return str.slice(str.indexOf('-') + 1);
    },
    reload: function reload() {
      var _this = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      var params = {
        eventId: this.eventId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      return new Promise(function (resolve, reject) {
        apieventmeslist(params).then(function (res) {
          resolve(res);
          if (!reset) {
            _this.list = Object.freeze([].concat(_toConsumableArray(_this.list), _toConsumableArray(res.data)));
          } else {
            _this.list = Object.freeze(res.data);
            setTimeout(function () {
              _this.$vux.loading.hide();
            }, 300);
          }
        });
      });
    },
    // 下拉刷新
    onPulldownLoading: function onPulldownLoading() {
      var _this2 = this;
      this.reload(true).then(function () {
        _this2.$refs['scrollerList'].donePulldown();
      });
    },
    // 上拉加载
    onPullupLoading: function onPullupLoading() {
      var _this3 = this;
      this.pageIndex = this.pageIndex + 1;
      this.reload().then(function (res) {
        if (res.data.length === 0) {
          _this3.$refs['scrollerList'].disablePullup();
        } else {
          _this3.$refs['scrollerList'].donePullup();
        }
      });
    },
    showPics: function showPics(i, index) {
      var _this4 = this;
      this.picsForPreviewer = this.list[index].images.map(function (item) {
        return {
          src: item.file_url
        };
      });
      this.$nextTick(function () {
        _this4.$refs['previewer'].show(i);
      });
    }
  },
  created: function created() {
    this.reload();
  }
};